import React, { useState } from "react";
import Card from "@/components/Card";
import { Tabs } from "antd";
import { BacktestSel, BacktestType } from "@/features/backtest";
import { useRootSelector } from "@/infrastructure/hooks";
import { TitleCamelCase } from "@/utils/string";
import { DollarOutlined, FieldTimeOutlined, TransactionOutlined } from "@ant-design/icons/lib";
import StatsTable from "./StatsTable"

const { TabPane } = Tabs;

type TabKey = keyof BacktestType.PortfolioStats;

export default () => {
  const [activeKey, setActiveKey] = useState<TabKey>("riskReturn");
  const pfStrategyStats = useRootSelector(BacktestSel.pfStrategyStats);

  const iconMap: Record<TabKey, JSX.Element> = {
    riskReturn: <DollarOutlined />,
    time: <FieldTimeOutlined />,
    trades: <TransactionOutlined />
  };

  return (
    <Card title={"Statistics"}>
      <Tabs activeKey={activeKey} onChange={e => setActiveKey(e as TabKey)}>
        {(Object.keys(pfStrategyStats) as TabKey[])
          .sort((a, b) => a.localeCompare(b))
          .map(e => (
            <TabPane
              tab={
                <span>
                  {iconMap[e]}
                  {TitleCamelCase(e)}
                </span>
              }
              key={e}
            >
              <StatsTable selectKey={e}/>
            </TabPane>
          ))}
      </Tabs>
    </Card>
  );
};
